import { styled, keyframes, Box } from "@mui/material";

// Dynamic shimmer animation based on parent width
const placeholderShimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

// Styled Box with proper gradient shimmer
const Shimmer = styled(Box)({
  width: "100%",
  height: "100%",
  backgroundImage: "linear-gradient(to right, transparent 0%, #edeef1 25%, transparent 50%, transparent 100%)",
  backgroundRepeat: "no-repeat",
  backgroundSize: "300% 100%", // Makes the shimmer wider for a smooth transition
  display: "inline-block",
  position: "relative",
  animation: `${placeholderShimmer} 1.5s linear infinite`,
});

export default Shimmer;
